// extracted by mini-css-extract-plugin
export default {"header":"Header_header__aR5GF","headerFlex":"Header_headerFlex__h9q0r","location":"Header_location__NuBQq"};